<template>
  <div class="pl-4">
    <purtrak-table name="qbolog" objectType="entries" :defaultColumns="defaultColumns" :headers="headers" ref="table"
                   listEndPoint="qboLog" fields="date,log,error" hide-action
                   :listFilters="listFilters" include-refresh
                   title="QBO Log"
                   :item-class="item => item.error == 0 ? '' : (item.error == 1 ? 'warning--text' : 'error--text')"
                   :print-info="{pageSize:'portrait', subTitle:[from?dateDisplay:'']}"
                   download-endpoint="qboLogExportCSV">
      <template v-slot:filter>
        <filter-menu include-reset @reset="error=0,from=null;to=nulll;search=''">
          <v-list-item>
            <filter-search label="Search" v-model="search"/>
          </v-list-item>
          <v-list-item>
            <date-range :from.sync="from" :to.sync="to" v-model="dateDisplay" option="All" allow-all/>
          </v-list-item>
          <v-list-item>
            <v-autocomplete label="Status" dense outlined :items="[{value:'0',text:'All'},{divider:true},{value:'1',text:'Warning'},{value:'2',text:'Error'}]" v-model="error"/>
          </v-list-item>
        </filter-menu>
        <template v-if="!$vuetify.breakpoint.mobile">
          <v-chip v-show="search" close small class="ml-1" @click:close="search=''">{{search}}</v-chip>
          <v-chip v-show="from!=null" close small class="ml-1" @click:close="from=null;to=null">{{dateDisplay}}</v-chip>
          <v-chip v-show="error!='0'" close small class="ml-1" @click:close="error='0'">{{error=='1'?'Warning':'Error'}}</v-chip>
        </template>
      </template>
      <template v-slot:menu>
        <v-list-item @click="showConfirm=true"><v-list-item-title>Clear log</v-list-item-title></v-list-item>
      </template>

      <template v-slot:item.date="{value}">
        {{value | formatDateTime}}
      </template>
      <template v-slot:item.error="{value}">
        <v-icon v-if="value == '1'" class="warning--text">mdi-alert</v-icon>
        <v-icon v-else-if="value == '2'" class="error--text">mdi-alpha-x-circle</v-icon>
      </template>
    </purtrak-table>

    <v-dialog v-model="showConfirm" persistent max-width="400">
      <v-card>
        <v-card-title>Clear log</v-card-title>
        <v-divider/>
        <v-card-text class="pt-4">
          Are you sure you want to <strong>permanently</strong> clear the log?
        </v-card-text>
        <v-divider/>
        <v-card-actions class="pr-6">
          <v-spacer></v-spacer>
          <v-btn color="error" plain @click="clearLog()">Clear log</v-btn>
          <v-btn color="primary" @click="showConfirm=false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

export default {
  name: 'AppsQboLog',
  data() {
    return {
      search: '',
      from: null,
      to: null,
      error: '0',
      dateDisplay: '',
      showConfirm: false,
      defaultColumns: [{ value: 'error', visible:true},
                       { value: 'date', visible:true},
                       { value: 'log', visible:true}],
      headers: [{ text: 'DATE', value: 'date', width:'20%',sortable:true},
                { text: 'LOG', value: 'log', width:'75%',sortable:false},
                { text: '', value: 'error', width:'5%',sortable:true,align:'center'}]
    }
  },
  computed: {
    listFilters() {
      const filters = [];
      if (this.search)
        filters.push({field:'log', comparator:'contains', value:this.search});
      if (this.from)
        filters.push({field:'date', comparator:'ge', value:`${this.from} 00:00:00`});
      if (this.to)
        filters.push({field:'date', comparator:'le', value:`${this.to} 23:59:59`});
      if (this.error !== '0')
        filters.push({field:'error', comparator:'eq', value:this.error});
      return filters;
    }
  },
  methods: {
    async clearLog() {
      const results = await this.$apiCall(`mutation AppsQboLog {qboClearLog}`, {});
      if (!results.error) {
        this.$refs.table.buildList();
      this.showConfirm = false;
      }
    }
  }
}
</script>
